import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getHastalar } from '../services/api';

const MIN_KARAKTER = 3;

export default function Hastalar() {
  const navigate = useNavigate();
  const [ara, setAra] = useState('');
  const [hastalar, setHastalar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [arandi, setArandi] = useState(false);   // en az bir arama yapıldı mı
  const zamanlayici = useRef(null);

  const aramaYap = (q) => {
    setYukleniyor(true);
    setArandi(true);
    getHastalar(q)
      .then(res => setHastalar(res.data))
      .catch(() => setHastalar([]))
      .finally(() => setYukleniyor(false));
  };

  // En az 3 karakterde, yazmayı bırakınca (debounce) otomatik ara
  useEffect(() => {
    const q = ara.trim();
    if (zamanlayici.current) clearTimeout(zamanlayici.current);
    if (q.length < MIN_KARAKTER) {
      setHastalar([]);
      setArandi(false);
      setYukleniyor(false);
      return;
    }
    zamanlayici.current = setTimeout(() => aramaYap(q), 400);
    return () => zamanlayici.current && clearTimeout(zamanlayici.current);
  }, [ara]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const q = ara.trim();
    if (q.length >= MIN_KARAKTER) aramaYap(q);
  };

  const azKarakter = ara.trim().length > 0 && ara.trim().length < MIN_KARAKTER;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 className="sayfa-baslik">Hastalar</h1>
          <p className="sayfa-alt">İsim, TC kimlik veya telefon numarası ile arama yapın (en az {MIN_KARAKTER} karakter).</p>
        </div>
        <button className="btn" onClick={() => navigate('/hasta-yeni')}>+ Yeni Hasta</button>
      </div>

      <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 10, marginBottom: 18, maxWidth: 520 }}>
        <input
          className="input"
          placeholder="🔍 Hasta adı, TC veya telefon…"
          value={ara}
          onChange={e => setAra(e.target.value)}
          autoFocus
        />
        <button className="btn" type="submit">Ara</button>
      </form>

      {/* Aramadan önce / az karakter / sonuç durumlarına göre içerik */}
      {!arandi ? (
        <div className="kart">
          <div className="bos-durum">
            {azKarakter
              ? `Aramak için en az ${MIN_KARAKTER} karakter yazın.`
              : '🔍 Hasta aramak için yukarıya isim, TC veya telefon yazın.'}
          </div>
        </div>
      ) : (
        <>
          <div className="kart" style={{ overflow: 'hidden' }}>
            {yukleniyor ? (
              <div className="bos-durum">Aranıyor…</div>
            ) : hastalar.length === 0 ? (
              <div className="bos-durum">Kayıt bulunamadı.</div>
            ) : (
              <table className="tablo">
                <thead>
                  <tr>
                    <th style={{ width: 80 }}>No</th>
                    <th>Hasta Adı</th>
                    <th style={{ width: 70 }}>Yaş</th>
                    <th style={{ width: 90 }}>Cinsiyet</th>
                    <th style={{ width: 160 }}>Telefon</th>
                  </tr>
                </thead>
                <tbody>
                  {hastalar.map(h => (
                    <tr key={h.kayitNo} onClick={() => navigate(`/hasta/${h.kayitNo}`, { state: { fromLabel: 'Hasta Listesine Geri Dön' } })}>
                      <td style={{ color: 'var(--metin-soluk)' }}>{h.kayitNo}</td>
                      <td style={{ fontWeight: 600 }}>{h.hesapAdi}</td>
                      <td>{h.yas ?? '—'}</td>
                      <td>
                        {h.cinsiyet === 'E' ? <span className="rozet rozet-e">Erkek</span>
                          : h.cinsiyet === 'K' ? <span className="rozet rozet-k">Kadın</span>
                          : <span className="rozet rozet-gri">—</span>}
                      </td>
                      <td>{h.cepTel || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          {!yukleniyor && hastalar.length > 0 && (
            <div style={{ marginTop: 10, fontSize: 13, color: 'var(--metin-soluk)' }}>
              {hastalar.length} kayıt listeleniyor{hastalar.length >= 100 ? ' (ilk 100)' : ''}.
            </div>
          )}
        </>
      )}
    </div>
  );
}
